export default __webpack_public_path__ + "static/media/alba-festival-history-2019.f517957d.jpg";